import React, { Component } from 'react';
import { Input } from 'semantic-ui-react';

export default class PlateAttach extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		var value1 = "", value2 = "";
		
		if (typeof props.plate != "undefined")
		{
			value1 = props.plate.replace(/[^a-zA-Z]+/g, '');
			value2 = props.plate.replace(/[^0-9]+/g, '');
		}
		
		this.state = {
			focused: 0,
			loading: false,
			disabled: false,
			value1: value1,
			value2: value2,
			f1error: false,
			f2error: false
		};
		
		this.onKeyDown = this.onKeyDown.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.callbackRequest = this.callbackRequest.bind(this);
	}
	
	onFocus = (e) => {this.setState({ focused: e.target.tabIndex });e.target.select();};
	
	onBlur = () => this.setState({ focused: 0 });
	
	onKeyDown(e) {
		
		e.stopPropagation();
		
		// On right arrow press go to next field
		if (e.keyCode == 39 && e.target.selectionStart == e.target.value.length)
		{
			e.preventDefault();
			
			this.refs[2].focus();
		}
		// On left arrow press go to previews field
		else if (e.keyCode == 37 && e.target.selectionStart == 0)
		{
			e.preventDefault();
			
			this.refs[1].focus();
		}
	}
	
	handleChange(e) {
		
		var { f1error, f2error, value1, value2 } = this.state;
		
		const { refs, handleSave } = this;
		
		// Select next field on 3 chars
		if (e.target.selectionStart == 3 && e.target.value.length == 3)
		{
			refs[2].focus();
		}
		
		if (refs[1].inputRef.value.length != refs[1].inputRef.value.replace(/[^A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώ]+/g, '').length)
		{
			f1error = true;
		}
		else
		{
			f1error = false;
		}
		
		if (refs[2].inputRef.value.length != refs[2].inputRef.value.replace(/[^0-9]+/g, '').length)
		{
			f2error = true;
		}
		else
		{
			f2error = false;
		}
		
		// Save value
		if (e.target.getAttribute("tabindex") == 1)
		{
			value1 = e.target.value;
		}
		else
		{
			value2 = e.target.value;
		}
		
		// Save plate when the two fields are not empty and have no errors
		if (refs[1].inputRef.value != "" && refs[2].inputRef.value != "" && !f1error && !f2error)
		{
			this.setState({ f1error, f2error, value1, value2 }, handleSave);
		}
		else
		{
			this.setState({ f1error, f2error, value1, value2 });
		}
	}
	
	handleSave = _.debounce(value => {
		
		this.setState({ loading: true });
		
		if (!document.getElementById("loading-screen"))
		{
			setTimeout(() => {this.callbackRequest({})}, 500);
		}
		else
		{
			const { value1, value2 } = this.state;
			
			const { valuationId } = this.props;
			
			if (typeof valuationId == "undefined")
			{
				return;
			}
			
			attachPlateRequest = new ActionRequest(
				"action_attach_plate",
				{ id: valuationId, plate: value1 + value2 }
			);
			
			attachPlateRequest.Success = this.callbackRequest;
			
			attachPlateRequest.Fail = this.callbackRequest;
			
			attachPlateRequest.Trigger();
		}
		
	}, 500);
	
	callbackRequest(response) {
		
		if (response.success)
		{
			const { value1, value2 } = this.state;
			
			this.setState({ loading: false });
			
			selected.plate = value1 + value2;
			
			history.replaceState(
				{ code: selected.code, km: selected.km, plate: selected.plate, date: selected.date },
				null,
				"/code/" + selected.code + "/km/" + selected.km + "/plate/" + selected.plate +
				"/date/" + selected.date
			);
		}
		else
		{
			this.setState({ f1error: true, f2error: true, loading: false });
		}
	}
	
	render() {
		
		const { focused, loading, disabled, f1error, f2error, value1, value2 } = this.state;
		
		const { onKeyDown, handleChange, onFocus, onBlur } = this;
		
		const props = {
			disabled: disabled,
			onFocus: onFocus,
			onBlur: onBlur,
			onKeyDown: onKeyDown,
			onChange: handleChange
		};
		
		return <div className="plate-attach-content">
			<Input
				size="mini"
				maxLength="3"
				ref={1}
				tabIndex={1}
				value={value1}
				placeholder="AAA"
				error={f1error}
				{...props}
			/>
			<Input
				size="mini"
				maxLength="1"
				value="-"
				disabled
			/>
			<Input
				size="mini"
				maxLength="4"
				ref={2}
				tabIndex={2}
				value={value2}
				placeholder="0000"
				error={f2error}
				loading={loading}
				{...props}
			/>
		</div>;
	}
}